import { Recording } from "@/models/recording";
import { createContext } from "react";

export type RowSelectedType = {
  row: string;
  exports: Set<string>;
};

export interface RowSelectionContextType {
  selecteds: Map<string, RowSelectedType>;
  onSelect(key: string, value?: RowSelectedType): void;
  onSelectAll(items: RowSelectedType[], selectAll: boolean): void;
  resetSelection(): void;
  isRowSelected(item: string): boolean;
  expandedRows: string[];
  onAddExpandedRow(recordingId: string): void;
  onResetExpandedRow(): void;
  isSelectDisabled(recording: Recording): boolean;
}

export const RowSelectionContext = createContext<RowSelectionContextType | null>(null);
